var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.307 16.769a6.155 6.155 0 0 1-6.154-6.155V5.691A1.231 1.231 0 0 1 7.384 4.46h1.231a1.231 1.231 0 0 0 0-2.462H7.384a3.693 3.693 0 0 0-3.693 3.693v4.923a8.592 8.592 0 0 0 3.717 7.065 10.857 10.857 0 0 1 2.623 3.478 10.856 10.856 0 0 1 1.045 4.228 8.6165 8.6165 0 1 0 17.233 0v-1.4a4.924 4.924 0 1 0-2.462 0v1.4a6.155 6.155 0 1 1-12.309 0 10.857 10.857 0 0 1 3.693-7.706 8.592 8.592 0 0 0 3.693-7.065V5.691a3.693 3.693 0 0 0-3.693-3.693H16a1.231 1.231 0 0 0 0 2.462h1.231a1.231 1.231 0 0 1 1.231 1.231v4.923a6.155 6.155 0 0 1-6.155 6.155Zm14.771 4.924a2.462 2.462 0 1 1 1.741-.721 2.462 2.462 0 0 1-1.741.721Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.d123e492fb0d314d4cf673c14537ef24.svg";
export { ForwardRef as ReactComponent };